// Single source of truth for the Pro free-trial length. Lives in its own module
// (no db/server imports) so both the server checkout handler and client UI can
// import it without dragging server-only code into the bundle.
export const PRO_FREE_TRIAL_DAYS = 3

// Headline Pro price shown on the upgrade dialog and the /pro marketing page.
// Display-only — the real amount charged is the Stripe price (getStripePriceId).
export const PRO_PRICE_YEARLY = 39.95
